import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-dialog-title',
    templateUrl: './dialog-title.component.html',
    styleUrls: ['./dialog-title.component.scss'],
})
export class DialogTitleComponent {
    @Input() title = '';
    @Input() isMobileFullScreen = false;

    @Output() close = new EventEmitter();

    constructor() {}

    closeDialog(): void {
        this.close.emit();
    }
}
